module.exports = "/_next/static/images/PersonalizeCampaigns@2x-d8963fe62ab500aea0f628c9dfc45596.png";